var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.request)?_c('div',{staticClass:"d-flex align-items-center"},[_c('Status',{attrs:{"status":_vm.request.status}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }